// extracted by mini-css-extract-plugin
export default {"h2":"Projects_h2__7TrUT","projects":"Projects_projects__AlbnG","content":"Projects_content__paQR5"};